import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'

import AppToolbar from '../../AppBar/AppToolbar'

const classes = {
    root: {
        backgroundColor: 'background.paper',
        borderRadius: 1,
        border: (theme) => `1px ${theme.palette.grey[300]} solid`,
        width: '100%',
        height: 'calc(100vh - 154px)',
        gap: 3,
    },
    sorryImage: {
        width: '700px',
    },
    sorryMessage: {
        gap: 1,
    },
}

const GenericErrorPage = () => {
    const { t } = useTranslation()

    const navigate = useNavigate()

    return (
        <>
            <AppToolbar />
            <Grid
                component="section"
                size={12}
                container
            >
                <Box
                    sx={[
                        {
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            p: 12,
                        },
                        classes.root,
                    ]}
                >
                    <Box
                        alt="Sorry"
                        component="img"
                        src="sorry.svg"
                        sx={classes.sorryImage}
                    />

                    <Box
                        sx={[
                            {
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                            },
                            classes.sorryMessage,
                        ]}
                    >
                        <Typography variant="h4">{t('Something went wrong.')}</Typography>
                        <Typography variant="body2">
                            {t("It's not you, it's us, please try that again, or contact support for help.")}
                        </Typography>
                    </Box>

                    <Button
                        color="primary"
                        size="large"
                        variant="contained"
                        onClick={() => navigate('/')}
                    >
                        {t('Back to your dashboard')}
                    </Button>
                </Box>
            </Grid>
        </>
    )
}

export default GenericErrorPage
